export const ERROR_ADDRESS_NOT_FOUND: String = "Address not found. Please enter valid street address.";
export const ERROR_STATE_NOT_SUPPORTED: String = "Sorry, card is not available in this state";
